import script from "./AdministratorShowcaseAgreementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorShowcaseAgreementForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorShowcaseAgreementForm.vue?vue&type=style&index=0&id=0fdbcb4f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdbcb4f"]])

export default __exports__